import {
  AcceptedValuesResourceType,
  AttributeDefinition,
  AttributeValidationEnumConfig
} from "@wingspanhq/wingspan-api-sdk";
import {
  IPayeeEngagementResponse,
  IPayerEngagementResponse
} from "@wingspanhq/payments/dist/interfaces";
import get from "lodash/get";

export function isDynamicEnumConfig(
  config: AttributeValidationEnumConfig
): boolean {
  return (
    "resourceType" in config &&
    "valuePath" in config &&
    "acceptedValues" in config
  );
}

export function isStaticEnumConfig(
  config: AttributeValidationEnumConfig
): boolean {
  return "acceptedValues" in config;
}

// The resource object powering dynamic enum lookups is still supplied by the v1
// payee-engagement read (out of scope for this migration), so its type stays v1.
export type AcceptedValuesResources = {
  payerPayeeEngagement?: IPayerEngagementResponse | IPayeeEngagementResponse;
};

export function getEnumValues(
  definition: AttributeDefinition,
  resources: AcceptedValuesResources
) {
  const config = definition.validationRules?.enumConfig;
  if (!config) {
    return [];
  }

  if (isDynamicEnumConfig(config)) {
    let resource: Record<string, any>;
    switch (config.resourceType) {
      case AcceptedValuesResourceType.PAYER_PAYEE_ENGAGEMENT:
        if (!resources.payerPayeeEngagement) {
          console.error(
            "PayerPayeeEngagement is required for dynamic enum values"
          );
          return [];
        }
        resource = resources.payerPayeeEngagement;
        break;
      default:
        return [];
    }

    const values = get(resource, config.valuePath ?? "");

    return Array.isArray(values) ? values : [values];
  }

  if (isStaticEnumConfig(config)) {
    return config.acceptedValues || [];
  }

  return [];
}
